export default [
  {
    label: 'Brief Data',
    value: 'brief',
  },
  {
    label: 'Program Statistics',
    value: 'summarize_program_data',
  },
  {
    label: 'Member Feedbacks',
    value: 'member_feedback',
  },
  {
    label: 'Top Topics',
    value: 'topics',
  },
  {
    label: 'Assessments Progress',
    value: 'assessments_progress',
  },
  {
    label: 'Assessments Data',
    value: 'assessments_data',
  },
];
